"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayeverPaymentType = void 0;
const payment_type_country_dependent_fee_nst_1 = require("@breakmedia/prime-vue-payment/src/api/payment.type.country.dependent.fee.nst");
const path = require('path');
const LABEL = 'Payever';
class PayeverPaymentType extends payment_type_country_dependent_fee_nst_1.PaymentTypeCountryDependentFee {
    constructor() {
        super(...arguments);
        this.indexname = 'payever';
        this.label = LABEL;
        this.vueJsComponent = 'payever-payment-type';
        this.configurationComponentAssets = [
            {
                id: 'payever-payment-type_script',
                tag: 'script',
                attributes: {
                    type: 'text/javascript',
                },
                content: path.join(__dirname, '../../dist/payever-settings.js'),
            },
            {
                id: 'payever-payment-type_style',
                tag: 'style',
                content: path.join(__dirname, '../../dist/css/app.css'),
            },
            {
                id: 'material-icons',
                tag: 'link',
                attributes: {
                    href: 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900|Material+Icons',
                    rel: 'stylesheet',
                },
            },
        ];
        this.configurationComponentTag = '<payever-settings></payever-settings>';
    }
    static getLabel() {
        return LABEL;
    }
}
exports.PayeverPaymentType = PayeverPaymentType;
//# sourceMappingURL=index.js.map